import React, {Component} from 'react'
import {CSSTransition, TransitionGroup} from 'react-transition-group'
import BackSound from '../../components/BackSound'
import NavContent from '../../components/NavContent'
import Wrap from './HomeWrap'

import CircleDecor1 from '../../components/Svg/circle-decor-1'
import CircleDecor2 from '../../components/Svg/circle-decor-2'
import CircleDecor3 from '../../components/Svg/circle-decor-3'
import IconTh from '../../components/Svg/icon-th'
import RGlow2 from '../../components/Svg/radial-glow-2'
import PointerLine1 from '../../components/Svg/pointer-line-1'
import BodyDecor3 from '../../components/Svg/body-decor-3'
import { withUiContext } from "../../UiContext";

import Languages from '../../const/languages'

class Home extends Component {
    state = {
        navContent: false,
    }

    toggleNav = (e) => {
        const {navContent} = this.state
        if (navContent) {
            this.setState({navContent: false})
        } else {
            this.setState({navContent: true})
        }
        // this.setState((prevState) => ({navContent: !prevState.navContent}))
    }

    render() {
        const {navContent} = this.state

        return (
            <Wrap navContent={navContent}>
                <div className="hud__container-content">
                    <div className={`nav__toggler animated slow ${!navContent ? 'fadeInLeft' : 'fadeOutLeft'}`} onMouseEnter={this.props.ui.playOverSound}>
                        <div className="btn btn-nav" data-id="0" data-menu-item-parent="" onClick={this.toggleNav}>
                            <div className="btn__icon">
                                <IconTh/>
                            </div>

                            <div className="btn__circles">
                                <div className="btn__circles__item"><CircleDecor1/></div>
                                <div className="btn__circles__item"><CircleDecor2/></div>
                                <div className="btn__circles__item"><CircleDecor3/></div>
                            </div>

                            <div className="btn__glow">
                                <RGlow2/>
                            </div>

                            <div className="btn__pointer">
                                <div className="btn__line">
                                    <PointerLine1/>
                                </div>

                                <div className="btn__pointer__label">
                                    {navContent ? Languages.closeMenu : Languages.openMenu}
                                </div>

                                <div className="btn__pointer__decor">
                                    <BodyDecor3/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <TransitionGroup className="menu-outer">
                        {navContent &&
                            <CSSTransition timeout={300} classNames="menu-transition">
                                <NavContent onClose={this.toggleNav}/>
                            </CSSTransition>
                        }
                    </TransitionGroup>
                </div>

                <div className="hud__container-controls">
                    <BackSound navContent={navContent} />

                    {/*buttonLink Close*/}
                </div>
            </Wrap>
        )
    }
}

export default withUiContext(Home)
